import { render, staticRenderFns } from "./UploadCardMediaDialog.vue?vue&type=template&id=632aeeec"
import script from "./UploadCardMediaDialog.vue?vue&type=script&lang=js"
export * from "./UploadCardMediaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports